import ImagesContainer from './images-container';

export default ImagesContainer;
